class VideoBackgroundComponent extends HTMLElement {
  connectedCallback() {
    if (this.dataset.horizonInitialized === 'true') return;

    const video = this.querySelector('[data-horizon-video-background]');
    if (!(video instanceof HTMLVideoElement)) return;

    for (const source of video.querySelectorAll('source[data-video-source]')) {
      const sourceUrl = source.dataset.videoSource;
      if (sourceUrl) source.src = sourceUrl;
    }

    video.load();
    this.dataset.horizonInitialized = 'true';
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
